module.exports = __webpack_public_path__ + "static/media/technology.614e4494.svg";